






































import {Component, Vue} from "vue-property-decorator";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";
import ImageShow from "@/components/ImageShow.vue";
import Select35 from "@/components/inputs/Select35.vue";

export class homeCards {
    no !: number;
    title : string = "";
    description : string = "";
    icon : string = "";
}
export class hcData {
    items : any = [];
}
@Component({
    components: {
        Select35,
        ImageShow,
        EnabledSwitch,
        EForm,Number,TextField
    }
})
export default class HomeCards extends  Vue{
    action : string = "config/home_cards";
    data : hcData = new hcData();
    item : homeCards = new homeCards();
    headers = [
        {text: "Sıra",      value: "no"},
        {text: "Başlık",  value: "title"},
        {text: "Açıklama",value: "description"},
        {text: "Icon",    value: "icon"},
        {text: "Sil", value: "action"},
    ];
    async get(){
        let response = await this.$http.get(this.action);
        this.data = response.data;
        this.data.items = JSON.parse(this.data.items);
    }
    async created(){
        await this.get();
    }
    async add(){
        this.data.items.push(this.item);
    }
    deleteItem(key : any){
        this.data.items.splice(key,1);
    }
};
